var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, reaction, computed, action } from "mobx";
export class DropDownController {
    constructor(config) {
        this.isOpened = false;
        this.showPlaceHolder = true;
        this.onOptionClick = (e) => {
            const target = e.target;
            if (target.hasAttribute("data-disabled")) {
                return;
            }
            const label = target.textContent || "";
            const value = target.getAttribute("data-value") || "";
            this.setSelected(value, label);
        };
        this.onChange = (e) => {
            this.setFilterValue(e.target.value);
        };
        this.onSelectChange = (e) => {
            const select = e.target;
            this.setSelected(e.target.value, select.options[select.selectedIndex].text);
        };
        this.onFocus = (e) => {
            // TODO: Test caret position on focus
            const value = e.target.value;
            e.target.value = "";
            e.target.value = value;
            this.showOptions();
        };
        this.onClick = () => {
            if (this.hasFilter && this.html.filter.current) {
                this.html.filter.current.focus();
            }
            else {
                this.showOptions();
            }
        };
        this.onBlur = () => {
            this.hideOptions();
        };
        this.getInitialItem = () => {
            let item = (this.showPlaceHolder ? (this.data.find((x) => !!x.selected)) : (this.data.length && this.data[0])) || { value: "", label: "" };
            return {
                value: item.value || "",
                label: item.label || ""
            };
        };
        this.data = config.data;
        this.hasFilter = config.hasFilter;
        this.filterNoResults = config.filterNoResults || "No results found.";
        this.html = config.html;
        this.onChangeCallback = config.onChangeCallback;
        this.onShowOptionsCallback = config.onShowOptionsCallback;
        this.onHideOptionsCallback = config.onHideOptionsCallback;
        this.showPlaceHolder = typeof (config.showPlaceHolder) === "undefined" ? true : !!config.showPlaceHolder;
        this.selected = this.getInitialItem();
        this.filter = this.hasFilter ? this.selected.label : "";
    }
    activate() {
        this.disposeOnValueChange = reaction(() => this.selected, () => execFunction(this.onChangeCallback, [this.selected.value]));
    }
    deactivate() {
        this.disposeOnValueChange();
    }
    showOptions() {
        this.isOpened = true;
        execFunction(this.onShowOptionsCallback, []);
    }
    hideOptions() {
        this.isOpened = false;
        this.setFilterValue(this.selected.label);
        execFunction(this.onHideOptionsCallback, []);
    }
    setSelected(value, label) {
        this.selected = {
            value,
            label
        };
        this.setFilterValue(label);
    }
    setFilterValue(value) {
        this.hasFilter && (this.filter = value);
    }
    get resultData() {
        let data = this.data;
        if (this.hasFilter) {
            const re = new RegExp(`^${this.filter.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&")}.*`, "i");
            data = this.data.filter(d => d.label.match(re));
            if (data.length === 0) {
                data = [{
                        value: "",
                        label: this.filterNoResults,
                        disabled: true
                    }];
            }
        }
        return data;
    }
}
__decorate([
    observable,
    __metadata("design:type", Boolean)
], DropDownController.prototype, "isOpened", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DropDownController.prototype, "selected", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], DropDownController.prototype, "filter", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DropDownController.prototype, "showOptions", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DropDownController.prototype, "hideOptions", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], DropDownController.prototype, "setSelected", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], DropDownController.prototype, "setFilterValue", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], DropDownController.prototype, "resultData", null);
function execFunction(fn, args) {
    typeof fn === "function" && fn.apply(undefined, args);
}
//# sourceMappingURL=DropDownController.js.map